import React from 'react'
import styles from './summary.module.css'

export default ({ children }) => (
  <div className={styles.summary} >{children}</div>
)
